module.exports = __webpack_public_path__ + "static/img/lunb.f658eba.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lunb.png
// module id = +zuo
// module chunks = 1